var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.baseClass, 'scroll--y', ( _obj = {}, _obj[(_vm.baseClass + "--bottom-fading")] = !_vm.bottomReached, _obj )],on:{"scroll":_vm.setBottomReached}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }